import { Content } from "@/types/PropTypes";
import ReactMarkdown from "react-markdown";
import styles from "./HowDeleteAccount.module.scss";
import { Base } from "../common/types";
import { DeleteIcon } from "@/svg";
import { DeleteAccountBtnProps } from "./type";

export const AdsWrapper: React.FC<Base> = ({ children }) => <div className={styles.adsWrapper}>{children}</div>;

export const ContentMarkupWrapper: React.FC<Base> = ({ children }) => (
  <div className={styles.contentMarkupWrapper}>{children}</div>
);

export const ContentMarkup: React.FC<Content> = ({ content }) => (
  <div className={styles.contentWrapper}>
    <ReactMarkdown>{content}</ReactMarkdown>
  </div>
);

export const AdsMobileWrapper: React.FC<Base> = ({ children }) => {
  return <div className={styles.adsMobileWrapper}>{children}</div>;
};

export const DeleteAccountBtn: React.FC<DeleteAccountBtnProps> = ({ onClick, title, disabled }) => (
  <button type="button" onClick={onClick} className={styles.deleteAccountBtn} disabled={disabled}>
    <DeleteIcon />
    {title}
  </button>
);
